<template>
<van-dialog v-model="show" class="FilePreviewer" :show-confirm-button="false">
  <Pdf v-if="fileType === FILE_TYPE.PDF" :url="previewData" />
  <Xlsx v-else-if="fileType === FILE_TYPE.XLSX" :url="previewData" />
  <Word v-if="fileType === FILE_TYPE.PDF" :url="previewData" />
</van-dialog>
</template>

<script>
import Pdf from "@/components/FilePreviewer/Pdf"
import Xlsx from "@/components/FilePreviewer/Xlsx"
import Word from "@/components/FilePreviewer/Word"

const FILE_TYPE  = {
  PDF: '.pdf',
  XLSX: '.xlsx',
  WORD: '.doc'
}
export default {
  name: "FilePreviewer",
  components: { Pdf, Word, Xlsx },
  data() {
    return {
      FILE_TYPE,
      show: false,
      previewData: '',
      fileType: ''
    }
  },
  methods: {
    open(previewData) {
      this.show = true
      if(previewData.endsWith(FILE_TYPE.PDF)) {
        this.fileType = FILE_TYPE.PDF
      }else if(previewData.endsWith(FILE_TYPE.XLSX)) {
        this.fileType = FILE_TYPE.XLSX
      }else if(previewData.endsWith(FILE_TYPE.WORD)) {
        this.fileType = FILE_TYPE.WORD
      }
      this.previewData = previewData
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scoped>

</style>
